
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://cbwdsviiosradpvssqiz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNid2Rzdmlpb3NyYWRwdnNzcWl6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg1MjI0ODIsImV4cCI6MjA2NDA5ODQ4Mn0.JMMdxrfJtCWdeVS9GEGQxwNWLz5ajDAyr-8vpvJmoAg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
